import React, {useEffect, useMemo, useState} from "react";
import styled from "styled-components/macro";
import { rgba } from "polished";
import { NavLink, withRouter } from "react-router-dom";
import { darken } from "polished";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../../../vendor/perfect-scrollbar.css";

import { spacing } from "@material-ui/system";

import {
  Badge,
  Box as MuiBox,
  Chip,
  Grid,
  Avatar,
  Collapse,
  Drawer as MuiDrawer,
  List as MuiList,
  ListItem,
  ListItemText,
  Typography,
  capitalize, MenuItem, Tooltip
} from "@material-ui/core";

import {
  Work as WorkIcon,
} from "@material-ui/icons";

import { ExpandLess, ExpandMore } from "@material-ui/icons";

import { green } from "@material-ui/core/colors";

import { sidebarSections as routes } from "./SidebarItems.comp";

import { ReactComponent as Logo } from "../../../assets/images/dq-icon-200x200.svg";
import {useAuth} from "../../../context/auth";
import {USER_ACCESS_LEVEL, INSIDER_MODULE_TYPE} from "../../../utils/constants";
import {GET_APP_LOCALIZE_TEXT} from "../../../utils/dq_lc_service/lc_service";
import {isDQInsiderORG, toastWarning} from "../../../utils/utils";
import Select from "@material-ui/core/Select";
import {ModulesLists} from "../../../services/organization.service";
import {useGlobalState} from "../../../context/global_state";
import {withStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const Box = styled(MuiBox)(spacing);

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const List = styled(MuiList)`
  background-color: ${(props) => props.theme.sidebar.background};
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)}px;
  padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
`;

const Brand = styled(ListItem)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(5)}px;
  padding-right: ${(props) => props.theme.spacing(5)}px;
  justify-content: center;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;

const BrandIcon = styled(Logo)`
  margin-right: ${(props) => props.theme.spacing(2)}px;
  color: ${(props) => props.theme.sidebar.header.brand.color};
  fill: ${(props) => props.theme.sidebar.header.brand.color};
  width: 32px;
  height: 32px;
`;

const BrandChip = styled(Chip)`
  background-color: ${green[700]};
  border-radius: 5px;
  color: ${(props) => props.theme.palette.common.white};
  font-size: 55%;
  height: 18px;
  margin-left: 2px;
  margin-top: -16px;
  padding: 3px 0;

  span {
    padding-left: ${(props) => props.theme.spacing(1.375)}px;
    padding-right: ${(props) => props.theme.spacing(1.375)}px;
  }
`;

const Category = styled(ListItem)`
  padding-top: ${(props) => props.theme.spacing(3)}px;
  padding-bottom: ${(props) => props.theme.spacing(3)}px;
  padding-left: ${(props) => props.theme.spacing(8)}px;
  padding-right: ${(props) => props.theme.spacing(7)}px;
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};

  svg {
    color: ${(props) => props.theme.sidebar.color};
    font-size: 20px;
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
      darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const CategoryText = styled(ListItemText)`
  margin: 0;
  span {
    color: ${(props) => props.theme.sidebar.color};
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
    padding: 0 ${(props) => props.theme.spacing(4)}px;
  }
`;

const CategoryIconLess = styled(ExpandLess)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const CategoryIconMore = styled(ExpandMore)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const Link = styled(ListItem)`
  padding-left: ${(props) => props.theme.spacing(17.5)}px;
  padding-top: ${(props) => props.theme.spacing(2)}px;
  padding-bottom: ${(props) => props.theme.spacing(2)}px;

  span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.7)};
  }

  &:hover span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.9)};
  }

  &:hover {
    background-color: ${(props) =>
      darken(0.015, props.theme.sidebar.background)};
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
      darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const LinkText = styled(ListItemText)`
  color: ${(props) => props.theme.sidebar.color};
  span {
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
  }
  margin-top: 0;
  margin-bottom: 0;
`;

const LinkBadge = styled(Chip)`
  font-size: 11px;
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  height: 20px;
  position: absolute;
  right: 28px;
  top: 8px;
  background: ${(props) => props.theme.sidebar.badge.background};

  span.MuiChip-label,
  span.MuiChip-label:hover {
    cursor: pointer;
    color: ${(props) => props.theme.sidebar.badge.color};
    padding-left: ${(props) => props.theme.spacing(2)}px;
    padding-right: ${(props) => props.theme.spacing(2)}px;
  }
`;

const CategoryBadge = styled(LinkBadge)`
  top: 12px;
`;

const SidebarSection = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  padding: ${(props) => props.theme.spacing(4)}px
    ${(props) => props.theme.spacing(7)}px
    ${(props) => props.theme.spacing(1)}px;
  opacity: 0.9;
  display: block;
`;

const SidebarFooter = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}px
    ${(props) => props.theme.spacing(4)}px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const SidebarFooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
`;

const SidebarFooterSubText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: 0.7rem;
  display: block;
  padding: 1px;
`;

const SidebarFooterBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)}px;
  text-transform: uppercase;
  span {
    background-color: ${(props) =>
      props.theme.sidebar.footer.online.background};
    border: 1.5px solid ${(props) => props.theme.palette.common.white};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const OrgIcon = styled.span`
  display: flex;
  padding-right: ${(props) => props.theme.spacing(2)}px;

  svg {
    width: 14px;
    height: 14px;
  }
`;

const FancyTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#1c2237",
        color: "#fff",
        boxShadow: "0 4px 12px #0003",
        fontSize: 15,
        fontWeight: 500,
        padding: 14,
        borderRadius: 8,
        letterSpacing: 0.1,
        maxWidth: 400,
    },
    arrow: {
        color: "#1c2237",
    },
}))(Tooltip);

const SidebarCategory = ({
  name,
  icon,
  classes,
  isOpen,
  isCollapsable,
  badge,
  ...rest
}) => {
  return (
    <Category {...rest}>
      {icon}
      <CategoryText>{name}</CategoryText>
      {isCollapsable ? (
        isOpen ? (
          <CategoryIconMore />
        ) : (
          <CategoryIconLess />
        )
      ) : null}
      {badge ? <CategoryBadge label={badge} /> : ""}
    </Category>
  );
};

const SidebarLink = ({ name, to, badge, icon }) => {
  return (
    <Link
      button
      dense
      component={NavLink}
      exact
      to={to}
      activeClassName="active"
    >
      <LinkText>{name}</LinkText>
      {badge ? <LinkBadge label={badge} /> : ""}
    </Link>
  );
};

function ReportSelectorDropdown({ options, selected, onChange }) {
    const selectedOption = options.find((opt) => opt.value === selected);
    const selectedLabel = selectedOption
        ? selectedOption.disabled
            ? `${selectedOption.label} (in progress)`
            : selectedOption.label
        : "Choose a Report";
    const handleMenuItemClick = (opt) => (e) => {
        if (opt.disabled) {
            e.preventDefault();
            e.stopPropagation();
            toastWarning('Report not available yet (in progress)');
        }
    };
  return (
      <Box px={2} py={2}>
        <Select
            fullWidth
            variant="outlined"
            value={selected}
            onChange={onChange}
            displayEmpty
            style={{
              background: "white",
              borderRadius: 8,
              fontWeight: 600,
              boxShadow: "0 1px 4px #0001",
              width: "100%",
              maxWidth: "100%"
            }}
            MenuProps={{
              anchorOrigin: { vertical: "bottom", horizontal: "left" },
              transformOrigin: { vertical: "top", horizontal: "center" },
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  maxWidth: "250px",
                  width: "100%",
                  maxHeight: "300px"
                }
              },
              MenuListProps: {
                style: {
                  padding: 0
                }
              }
            }}
            renderValue={() => (
                <span style={{ color: selectedOption?.disabled ? "#999" : "#1c2237" }}>
                    {selectedLabel}
                </span>
            )}
        >
          <MenuItem value="" disabled>
            <Typography style={{ fontWeight: 700 }}>Choose a Report</Typography>
          </MenuItem>
            {options.map((opt) => {
                const isDisabled = !!opt.disabled;
                const labelWithStatus = isDisabled
                    ? `${opt.label} (in progress)`
                    : opt.label;
                return (
                    <MenuItem
                        key={opt.value}
                        value={opt.value}
                        disabled={isDisabled}
                        style={{
                            width: "100%",
                            opacity: isDisabled ? 0.6 : 1,
                            cursor: isDisabled ? "not-allowed" : "pointer",
                        }}
                    >
                        {isDisabled ? (
                            <span style={{ display: "block", width: "100%", pointerEvents: "auto" }}>
                                <FancyTooltip title={labelWithStatus} placement="right" arrow>
                                    <span>
                                        <Typography
                                            noWrap
                                            style={{ maxWidth: 200, display: "block", width: "100%" }}
                                            onClick={handleMenuItemClick(opt)}
                                        >
                                            {labelWithStatus}
                                        </Typography>
                                    </span>
                                </FancyTooltip>
                            </span>
                        ) : (
                            <FancyTooltip title={labelWithStatus} placement="right" arrow>
                                <Typography
                                    noWrap
                                    style={{ maxWidth: 200, display: "block", width: "100%" }}
                                >
                                    {labelWithStatus}
                                </Typography>
                            </FancyTooltip>
                        )}
                    </MenuItem>
                );
            })}
        </Select>
      </Box>
  );
}


const Sidebar = ({ classes, staticContext, location, ...rest }) => {

  const { authUser } = useAuth();

  const [finalRoutes,setFinalRoutes] = useState(routes(location));

  const pageLc = location.pathname.split('/')[1];

  const [reportOptions, setReportOptions] = useState([]);

  const { settings, setSettings } = useGlobalState();
  const selectedReport = settings.selected_report || ""; // Get current selected report

  // When report is selected from dropdown:
  const handleReportChange = (e) => {
      const selectedOption = reportOptions.find(opt => opt.value === e.target.value);
      setSettings(prev => ({
          ...prev,
          selected_report: e.target.value,
          selected_module_type: selectedOption ? selectedOption.module_type || "" : "",
      }));
  };

  const initOpenRoutes = () => {
    /* Open collapse element that matches current url */
    const pathName = location.pathname;

    let _routes = {};

    // remove the ui_config from routes if that option is disable from admin-portal
    let final_routes = finalRoutes;
    console.log('authUser.org_obj.ui_config_enable --> ', authUser);
    if (!authUser.org_obj.ui_config_enable) {
      final_routes = routes.filter(route_collection => route_collection.path !== '/ui_config');
    }

    // Hide Efficacy tab when selected module type is ASSESSMENT
    if (isDQInsiderORG() && settings.selected_module_type === INSIDER_MODULE_TYPE.ASSESSMENT) {
      final_routes = final_routes.filter(s => s.path !== '/school/efficacy');
    }

    setFinalRoutes(final_routes);

    final_routes.forEach((route, index) => {
      const isActive = pathName.indexOf(route.path) === 0;
      const isOpen = route.open;
      const isHome = route.containsHome && pathName === "/";

      _routes = Object.assign({}, _routes, {
        [index]: isActive || isOpen || isHome,
      });
    });

    return _routes;
  };

    // useEffect hook to fetch org modules
    const orgCode = useMemo(() => authUser.org_obj.org_code, [authUser.org_obj.org_code]);
    useEffect(() => {
      async function fetchOrgModules() {
          if (isDQInsiderORG()) {
              const result = await ModulesLists.get_org_modules(orgCode);
              console.log('Org modules fetched:', result);
              if (authUser.access_level === USER_ACCESS_LEVEL.ANALYTICS_PORTAL_PARENT_ACCOUNT && Array.isArray(result.data.parent_modules)) {
                  const options = result.data.parent_modules.map(item => ({
                      value: `${item.user_id}___${item.module_code}`, // Unique!
                      label: `${item.user_name} — ${item.module_name}`,
                      disabled: !item.finished, // Only enable if finished
                      user_id: item.user_id,
                      module_type: item.module_type
                  }));

                  setReportOptions(options);

                  // Set default if no report is selected or if selected report doesn't exist
                  const firstFinished = options.find(opt => !opt.disabled);
                  if (firstFinished && (!settings.selected_report || !options.find(opt => opt.value === settings.selected_report))) {
                      setSettings(prev => ({
                          ...prev,
                          selected_report: firstFinished.value,
                          selected_module_type: firstFinished.module_type || "",
                      }));
                  }

              } else if (result && result.data && Array.isArray(result.data.org_modules)) {
                  const options = result.data.org_modules.map((mod) => ({
                      value: mod.module_code,
                      label: mod.module_name,
                      module_type: mod.module_type
                  }));
                  setReportOptions(options);

                  // Set default if no report is selected or if selected report doesn't exist
                  if (options.length > 0 && (!settings.selected_report || !options.find(opt => opt.value === settings.selected_report))) {
                      setSettings(prev => ({
                          ...prev,
                          selected_report: options[0].value,
                          selected_module_type: options[0].module_type || "",
                      }));
                  }
              }
          }
      }
      fetchOrgModules().then(r => console.log('Org modules fetched successfully'));
    }, [orgCode, authUser.access_level]);

  const [openRoutes, setOpenRoutes] = useState(() => initOpenRoutes());

  // Directly update finalRoutes when selected_module_type changes (hide/show Efficacy tab)
  useEffect(() => {
      if (isDQInsiderORG()) {
          let updated_routes = routes(location);
          if (!authUser.org_obj.ui_config_enable) {
              updated_routes = updated_routes.filter(s => s.path !== '/ui_config');
          }
          if (settings.selected_module_type === INSIDER_MODULE_TYPE.ASSESSMENT) {
              updated_routes = updated_routes.filter(s => s.path !== '/school/efficacy');
          }
          setFinalRoutes(updated_routes);
      }
  }, [settings.selected_module_type]);

  const toggle = (index) => {
    // Collapse all elements
    Object.keys(openRoutes).forEach(
      (item) =>
        openRoutes[index] ||
        setOpenRoutes((openRoutes) =>
          Object.assign({}, openRoutes, { [item]: false })
        )
    );

    // Toggle selected element
    setOpenRoutes((openRoutes) =>
      Object.assign({}, openRoutes, { [index]: !openRoutes[index] })
    );
  };

  return (
    <Drawer variant="permanent" {...rest}>
      <Brand component={NavLink} to={`/${pageLc}/`} button>
        {!isDQInsiderORG() && <BrandIcon />}{" "}
        {!isDQInsiderORG() && (
            <Box ml={1}>
              {`${GET_APP_LOCALIZE_TEXT(pageLc, 'navigation__analytics_dashboard')}`}
            </Box>
        )}
        {isDQInsiderORG() && (
            <Box ml={0} width="100%">
              <ReportSelectorDropdown
                  options={reportOptions}
                  selected={selectedReport}
                  onChange={handleReportChange}
              />
            </Box>
        )}
      </Brand>
      <Scrollbar>
        <List disablePadding>
          <Items>
            {finalRoutes.map((category, index) => (
              <React.Fragment key={index}>
                {category.header ? (
                  <SidebarSection>{category.header}</SidebarSection>
                ) : null}

                {category.children && category.icon ? (
                  <React.Fragment key={index}>
                    <SidebarCategory
                      isOpen={!openRoutes[index]}
                      isCollapsable={true}
                      name={category.id}
                      icon={category.icon}
                      button={true}
                      onClick={() => toggle(index)}
                    />

                    <Collapse
                      in={openRoutes[index]}
                      timeout="auto"
                      unmountOnExit
                    >
                      {category.children.map((route, index) => (
                        <SidebarLink
                          key={index}
                          name={route.name}
                          to={`/${pageLc}${route.path}`}
                          icon={route.icon}
                          badge={route.badge}
                        />
                      ))}
                    </Collapse>
                  </React.Fragment>
                ) : category.icon ? (
                  <SidebarCategory
                    isCollapsable={false}
                    name={category.id}
                    to={`/${pageLc}${category.path}`}
                    activeClassName="active"
                    component={NavLink}
                    icon={category.icon}
                    exact
                    button
                    badge={category.badge}
                  />
                ) : null}
              </React.Fragment>
            ))}
          </Items>
        </List>
      </Scrollbar>
      <SidebarFooter>
        <Grid container spacing={2}>
          <Grid item>
            <SidebarFooterBadge
              overlap="circle"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
            >
              <Avatar
                alt={authUser.email}
                src="/static/img/avatars/avatar-1.jpg"
              />
            </SidebarFooterBadge>
          </Grid>
          <Grid item>
            <SidebarFooterText variant="body2">{authUser.email}</SidebarFooterText>
            <SidebarFooterSubText variant="caption">
              {
                authUser.access_level === USER_ACCESS_LEVEL.FULL_ACCESS_ANALYTICS_PORTAL_SINGLE_INSTITUTE ?
                    `${authUser.org_obj.org_name} (${authUser.institute_code})`
                    : `Admin (${authUser.org_obj.org_name})`
              }
            </SidebarFooterSubText>
          </Grid>
        </Grid>
      </SidebarFooter>
    </Drawer>
  );
};

export default withRouter(Sidebar);
